import Layout from "components/Layout";
import Login from "components/authentication/Login";
import SignUp from "components/authentication/SignUp";
import TwoFactorAuth from "components/authentication/TwoFactorAuth";
import LandingPage from "components/landingPage";
import RfpType from "components/landingPage/RFP";
import CreateReport from "components/evaluation/CreateReport";
import VendorSummary from "components/evaluation/ScorecardReport";
import EvaluationScorecard from "components/evaluation/Eval";
import Settings from "components/dashboard/settings/Settings";
import HelpSupport from "components/dashboard/settings/support";
import NotFound from "components/authentication/NotFound";
import HomePage from "components/dashboard/homePage/HomePage";
import VerifyEmail from "components/authentication/VerifyEmail";
import { PricingTable } from "components/pricing/PricingTable";
import SectorSelectionPage from "components/landingPage/SectorSelectionPage";
import PaymentSuccess from "components/payment/PaymentSuccess";
import Billing from "components/dashboard/billing/Billing";
import Refine from "components/intake/buildScratch/refine/Refine";
import {
  ResetPassword,
  ForgotPassword,
  ThankYouPage,
  StyleGuide,
  Home,
  Dashboard,
  RFPPage,
  GenerateRFPContainer,
  AnalyzeJobFlow,
  OpenApplicationsPage,
  AnalysisPage,
  BuildFromScratch,
  RfpDefined,
  MarketingAutomation,
  GenerateReport,
  CheckoutPage,
  AnalysedApplicationsPage,
} from "./lazyComponents";

export interface RouteConfig {
  path: string;
  // Using React.ComponentType without generic to allow any component type
  component: React.ComponentType;
  isProtected?: boolean;
  allowUnauthenticatedPaths?: string[];
  layout?: React.ComponentType;
}

// Public Routes (No authentication required)
export const publicRoutes: RouteConfig[] = [
  { path: "/", component: Login },
  { path: "/signup", component: SignUp },
  { path: "/verify-email", component: VerifyEmail },
  { path: "/forgot-password", component: ForgotPassword },
  { path: "/reset-user-password", component: ResetPassword },
  { path: "/thank-you", component: ThankYouPage },
  { path: "/two-factor-auth", component: TwoFactorAuth },
  { path: "/style_guide", component: StyleGuide },
  { path: "/sector-selection", component: SectorSelectionPage },
];

// Protected Routes (Standalone - No layout wrapper)
export const protectedStandaloneRoutes: RouteConfig[] = [
  { path: "/choose_RFP", component: RfpType, isProtected: true },
  { path: "/create_report", component: CreateReport, isProtected: true },
  { path: "/get_report", component: VendorSummary, isProtected: true },
];

// Layout Routes (With Layout wrapper)
export const layoutRoutes: RouteConfig[] = [
  {
    path: "/evaluation",
    component: EvaluationScorecard,
    isProtected: true,
    layout: Layout,
  },
];

// Dashboard Routes (With DashboardLayout wrapper)
export const dashboardRoutes: RouteConfig[] = [
  // Core Dashboard
  { path: "/home", component: HomePage, isProtected: true },
  { path: "/dashboard", component: Dashboard, isProtected: true },
  { path: "/open-projects", component: Home, isProtected: true },

  // Settings & Support
  { path: "/settings", component: Settings, isProtected: true },
  { path: "/help-support", component: HelpSupport, isProtected: true },

  // Billing & Payments
  { path: "/upgrade", component: PricingTable, isProtected: true },
  { path: "/checkout", component: CheckoutPage, isProtected: true },
  { path: "/payment-success", component: PaymentSuccess, isProtected: true },
  { path: "/billing", component: Billing, isProtected: true },

  // RFP Management
  {
    path: "/rfp-defined",
    component: RfpDefined,
    isProtected: true,
    allowUnauthenticatedPaths: ["/rfp-defined"],
  },
  {
    path: "/build-scratch",
    component: BuildFromScratch,
    isProtected: true,
    allowUnauthenticatedPaths: ["/build-scratch"],
  },
  { path: "/build-scratch/eval", component: Refine, isProtected: true },
  {
    path: "/completed-analysis/:rfpId",
    component: MarketingAutomation,
    isProtected: true,
    allowUnauthenticatedPaths: ["/completed-analysis/:rfpId"],
  },
  { path: "/completed-analysis", component: RFPPage, isProtected: true },
  { path: "/deleted-analysis", component: RFPPage, isProtected: true },
  { path: "/generate-report", component: GenerateReport, isProtected: true },
  { path: "/created-rfp", component: GenerateRFPContainer, isProtected: true },

  // Landing Page (with special auth handling)
  {
    path: "/landing-page",
    component: LandingPage,
    isProtected: true,
    allowUnauthenticatedPaths: ["/landing-page"],
  },

  // HR Module Routes
  { path: "/analyze-job", component: AnalyzeJobFlow, isProtected: true },
  {
    path: "/analysed-application/:applicationId",
    component: AnalysisPage,
    isProtected: true,
  },
  {
    path: "/analysed-application",
    component: AnalysedApplicationsPage,
    isProtected: true,
  },
  {
    path: "/open-application",
    component: OpenApplicationsPage,
    isProtected: true,
  },
];

// Fallback route
export const notFoundRoute: RouteConfig = {
  path: "*",
  component: NotFound,
};

